// Global number coverage — extracted from our carrier's published coverage
// list. "t" is the number types available in that country:
//   local = geographic DID · mobile = mobile number · tollfree = toll-free
//   uifn  = Universal International Freephone Number
export const coverage = [
  { c: "Albania", t: ["local", "tollfree"] },
  { c: "American Samoa", t: ["tollfree"] },
  { c: "Angola", t: ["local"] },
  { c: "Anguilla", t: ["local", "tollfree"] },
  { c: "Antigua and Barbuda", t: ["mobile", "tollfree"] },
  { c: "Argentina", t: ["local", "tollfree", "uifn"] },
  { c: "Armenia", t: ["mobile"] },
  { c: "Australia", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Austria", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Bahamas", t: ["local", "tollfree"] },
  { c: "Bangladesh", t: ["local", "mobile", "tollfree"] },
  { c: "Barbados", t: ["local", "tollfree"] },
  { c: "Belgium", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Belize", t: ["local", "tollfree"] },
  { c: "Benin", t: ["mobile"] },
  { c: "Bermuda", t: ["tollfree"] },
  { c: "Bolivia", t: ["local", "tollfree"] },
  { c: "Bosnia and Herzegovina", t: ["local", "tollfree"] },
  { c: "Botswana", t: ["tollfree"] },
  { c: "Brazil", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "British Virgin Islands", t: ["local", "tollfree"] },
  { c: "Brunei", t: ["tollfree"] },
  { c: "Bulgaria", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Burkina Faso", t: ["local"] },
  { c: "Cambodia", t: ["local", "tollfree"] },
  { c: "Cameroon", t: ["local", "mobile"] },
  { c: "Canada", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Cayman Islands", t: ["local", "tollfree"] },
  { c: "Chile", t: ["local", "mobile", "tollfree"] },
  { c: "China", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Colombia", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Congo", t: ["mobile"] },
  { c: "Costa Rica", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Croatia", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Cuba", t: ["tollfree"] },
  { c: "Curacao", t: ["local"] },
  { c: "Cyprus", t: ["local", "tollfree", "uifn"] },
  { c: "Czech Republic", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Democratic Republic of the", t: ["mobile"] },
  { c: "Denmark", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Dominica", t: ["local", "tollfree"] },
  { c: "Dominican Republic", t: ["local", "tollfree"] },
  { c: "Ecuador", t: ["local", "mobile", "tollfree"] },
  { c: "Egypt", t: ["local", "mobile", "tollfree"] },
  { c: "El Salvador", t: ["local", "tollfree"] },
  { c: "Estonia", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Ethiopia", t: ["tollfree"] },
  { c: "Finland", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "France", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "French Guiana", t: ["local", "tollfree", "uifn"] },
  { c: "Georgia", t: ["local", "mobile", "tollfree"] },
  { c: "Germany", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Ghana", t: ["local", "mobile", "tollfree"] },
  { c: "Greece", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Grenada", t: ["local", "tollfree"] },
  { c: "Guadeloupe", t: ["local", "tollfree", "uifn"] },
  { c: "Guam", t: ["tollfree"] },
  { c: "Guatemala", t: ["local", "tollfree"] },
  { c: "Guinea", t: ["local", "mobile"] },
  { c: "Honduras", t: ["local", "mobile", "tollfree"] },
  { c: "Hong Kong", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Hungary", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Iceland", t: ["local", "tollfree", "uifn"] },
  { c: "India", t: ["local", "mobile", "tollfree"] },
  { c: "Indonesia", t: ["local", "mobile", "tollfree"] },
  { c: "Ireland", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Israel", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Italy", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Ivory Coast", t: ["local", "mobile"] },
  { c: "Jamaica", t: ["local", "tollfree"] },
  { c: "Japan", t: ["local", "tollfree", "uifn"] },
  { c: "Jordan", t: ["local", "tollfree"] },
  { c: "Kenya", t: ["local", "mobile", "tollfree"] },
  { c: "Kosovo", t: ["local"] },
  { c: "Kuwait", t: ["local"] },
  { c: "Kyrgyzstan", t: ["local", "mobile", "tollfree"] },
  { c: "Laos", t: ["mobile"] },
  { c: "Latvia", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Lesotho", t: ["tollfree"] },
  { c: "Liberia", t: ["mobile"] },
  { c: "Lithuania", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Luxembourg", t: ["local", "tollfree", "uifn"] },
  { c: "Macau", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Malaysia", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Malta", t: ["local", "tollfree", "uifn"] },
  { c: "Martinique", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Mauritius", t: ["local", "mobile", "tollfree"] },
  { c: "Mexico", t: ["local", "mobile", "tollfree"] },
  { c: "Moldova", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Monaco", t: ["tollfree", "uifn"] },
  { c: "Mongolia", t: ["tollfree"] },
  { c: "Montenegro", t: ["local", "mobile", "tollfree"] },
  { c: "Morocco", t: ["local", "mobile", "tollfree"] },
  { c: "Mozambique", t: ["mobile"] },
  { c: "Myanmar", t: ["local", "mobile", "tollfree"] },
  { c: "Namibia", t: ["mobile"] },
  { c: "Nepal", t: ["mobile", "tollfree"] },
  { c: "Netherlands", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Netherlands Antilles", t: ["local", "mobile"] },
  { c: "New Zealand", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Nicaragua", t: ["local", "mobile", "tollfree"] },
  { c: "Nigeria", t: ["local", "mobile", "tollfree"] },
  { c: "Norway", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Oman", t: ["tollfree"] },
  { c: "Pakistan", t: ["local", "mobile", "tollfree"] },
  { c: "Panama", t: ["local", "tollfree"] },
  { c: "Papua New Guinea", t: ["tollfree"] },
  { c: "Paraguay", t: ["local", "tollfree"] },
  { c: "Peru", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Philippines", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Poland", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Portugal", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Puerto Rico", t: ["local", "mobile", "tollfree"] },
  { c: "Qatar", t: ["local", "mobile", "tollfree"] },
  { c: "Republic of North Macedonia", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Republic of the Congo", t: ["mobile"] },
  { c: "Reunion", t: ["local", "tollfree", "uifn"] },
  { c: "Romania", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Rwanda", t: ["local"] },
  { c: "Saudi Arabia", t: ["local", "mobile", "tollfree"] },
  { c: "Serbia", t: ["local", "mobile", "tollfree"] },
  { c: "Seychelles", t: ["local"] },
  { c: "Singapore", t: ["local", "tollfree", "uifn"] },
  { c: "Slovakia", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Slovenia", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "South Africa", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "South Korea", t: ["local", "tollfree", "uifn"] },
  { c: "South Sudan", t: ["local"] },
  { c: "Spain", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Sri Lanka", t: ["local", "mobile", "tollfree"] },
  { c: "Sudan", t: ["local"] },
  { c: "Swaziland", t: ["mobile"] },
  { c: "Sweden", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Switzerland", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Taiwan", t: ["local", "tollfree", "uifn"] },
  { c: "Tanzania", t: ["local", "mobile", "tollfree"] },
  { c: "Thailand", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "Trinidad and Tobago", t: ["local", "tollfree"] },
  { c: "Tunisia", t: ["local"] },
  { c: "Turkey", t: ["local", "mobile", "tollfree"] },
  { c: "Turkmenistan", t: ["mobile"] },
  { c: "Uganda", t: ["local", "tollfree"] },
  { c: "Ukraine", t: ["local"] },
  { c: "United Arab Emirates", t: ["local", "mobile", "tollfree"] },
  { c: "United Kingdom", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "United States", t: ["local", "mobile", "tollfree", "uifn"] },
  { c: "United States Virgin Islands", t: ["local", "tollfree"] },
  { c: "Uruguay", t: ["local", "tollfree", "uifn"] },
  { c: "Uzbekistan", t: ["local", "mobile"] },
  { c: "Vietnam", t: ["local", "tollfree"] },
  { c: "Zambia", t: ["mobile"] },
  { c: "Zimbabwe", t: ["local"] },
];

export const TYPE_LABEL = {
  local: "Local",
  mobile: "Mobile",
  tollfree: "Toll-free",
  uifn: "UIFN",
};
